// extracted by mini-css-extract-plugin
export var actionIcon = "_u6-0";